import UserMessageFullScreen from 'components/screens/UserMessageFullScreen'
import { MessageTypes } from 'constants/message-screens'
import React, { ComponentType } from 'react'
import { useSelector } from 'react-redux'
import { selectUserIsLoggedIn } from 'redux/selectors'

const withOnlyAllowLoggedIn =
  <T,>(Component: ComponentType<T>, Fallback?: ComponentType): ComponentType<T> | ComponentType =>
  (props: T) => {
    const isLoggedIn = useSelector(selectUserIsLoggedIn)

    if (!isLoggedIn)
      return Fallback ? (
        <Fallback />
      ) : (
        <UserMessageFullScreen messageType={MessageTypes.PAGE_RESTRICTED} />
      )
    /*@ts-ignore */
    return <Component {...props} />
  }

export default withOnlyAllowLoggedIn
